function generateStrings(descriptions, state) {
  const result = [];

  let generatedString = '';

  for (const item of descriptions) {
    if (item.type === 'text' || item.type === 'label') {
      generatedString += item.text;
    } else if (item.type === 'field' && typeof item.field === 'string') {
      const fieldParts = item.field.split('.');
      let fieldValue = state;

      for (const fieldPart of fieldParts) {
        fieldValue = fieldValue?.[fieldPart];
        if (fieldValue === undefined) {
          break;
        }
      }

      // Always append something
      generatedString += fieldValue !== undefined ? fieldValue : 'n/a';
    }
  }

  result.push(generatedString);

  return result;
}

export default generateStrings;
